const payment = {
    getlist: 'payment/getlist',
    add: 'payment/add',
    update: 'payment/update',
    remove: 'payment/remove',
    get: 'payment/get',
    getall: 'payment/getall',
    clearcache: 'payment/clear-cache',
}
export default payment
